export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";